module.exports = __webpack_public_path__ + "static/media/couches-8.51a0e604.jpg";